import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, Checkbox, FormGroup, Grid, IconButton, TextField, Tooltip, styled, InputAdornment } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import Button from "../Button"
import moment from "moment";
import { KeyboardDatePicker } from "@material-ui/pickers";
import { MenuItem } from "@material-ui/core";
import ReactTableTabs from "./RateTableTabs";
import AddIcon from '@material-ui/icons/Add'
import { EditButton, EditSectionContainer, PlusButtonContainer } from "./EditButtonStyles";

const PlusIconMode = ({ rateClasses, rateTypes, zones, tdsps, doCreateTDSPRate, user_id, rowTDSPName, rowRateTypeName, showPlusMode, setShowPlusMode }) => {
    const time = moment.tz();
    const localtz = moment.tz.guess();
    const date = time.clone().tz(localtz);
    const startDate = moment(date).format("YYYY-MM-DD")
    const matching_tdsp_id = tdsps?.filter(tdsp => tdsp.name === rowTDSPName)
    const tdsp_id = matching_tdsp_id?.length > 0 ? matching_tdsp_id[0].ID : 0
    const matching_rate_type = rateTypes?.filter(type => type.type === rowRateTypeName)
    const rate_type_id = matching_rate_type?.length > 0 ? matching_rate_type[0].id : 0
    const [selectedDate, setSelectedDate] = useState(startDate);
    const [selectedEndDate, setSelectedEndDate] = useState(startDate);
    const [endDateNull, setEndDateNull] = useState(false)
    const [newRateRequest, setNewRateRequest] = useState({
        tdsp_id: tdsp_id,
        rate_type_id: rate_type_id,
        class_type_id: 0,
        zone_id: 0,
        rate: 0.0,
        start_date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
        end_date: null,
        user_id: user_id,
        status: "actual"
    })
    const statuses = ['actual', 'proposed', 'forecasted']

    const handleTDSPStatusChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            status: event.target.value
        }));
    }

    const handleTDSPRateClassChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            class_type_id: parseInt(event.target.value, 10)
        }));
    }

    const handleTDSPZoneChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            zone_id: parseInt(event.target.value, 10)
        }));
    }

    const handleTDSPRateChange = (event) => {

        let value = parseFloat(event.target.value) || ""

        if (parseFloat(event.target.value) === 0) {
            value = 0
        }

        if ((value < 0 || value > 0.99) && newRateRequest.rate_type_id !== "2" && newRateRequest.rate_type_id !== "7") {
            return
        }

        setNewRateRequest(prevState => ({
            ...prevState,
            rate: value
        }));
    }

    const handleEndDateNullClick = (event) => {
        setEndDateNull(event.target.checked)
    }

    useEffect(() => {

        if (moment(selectedEndDate).isBefore(moment(selectedDate))) {
            setSelectedEndDate(selectedDate)
        }

        setNewRateRequest(prevState => ({
            ...prevState,
            start_date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
            end_date: endDateNull === true ? null : `${moment(selectedEndDate).format("YYYY-MM-DD")}`
        }));
    }, [selectedDate, selectedEndDate, endDateNull]);

    useEffect(() => {
        if (showPlusMode) {
            setSelectedDate(moment(date).format("YYYY-MM-DD"))
            setSelectedEndDate(null)
            setNewRateRequest(prevState => ({
                ...prevState,
                start_date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
                end_date: null
            }));
        }
    }, [showPlusMode])

    const setCreateDisabled = (newRateRequest.rate <= 0.0 && newRateRequest.rate_type_id !== "7") ||
    newRateRequest.rate === "" ||
    isNaN(newRateRequest.rate) ||
    newRateRequest.end_date === "Invalid date" ||
    (newRateRequest.rate < 0.01 && newRateRequest.rate_type_id !== "2" && newRateRequest.rate_type_id !== "7") ||
    newRateRequest.class_type_id === 0;

    return (
        <Dialog
            open={showPlusMode}
            ariaHideApp={false}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle style={{ marginRight: '20px', marginLeft: '20px' }}>
                Create Rate
            </DialogTitle>
            <DialogContent style={{ overflow: 'hidden' }}>
                <DialogContentText style={{ marginRight: '20px', marginLeft: '20px' }}>
                    <Grid container>
                        <Grid style={{ gap: '20px', display: 'flex', alignItems: 'center' }} item sm={12}>
                            <KeyboardDatePicker
                                label="Start Date*"
                                dateformat="YYYY-MM-DD"
                                value={moment(selectedDate).tz(localtz)}
                                minDate={moment("1900-01-01")}
                                onChange={() => null}
                                onAccept={(value) => {
                                    setSelectedDate(moment(value).format("YYYY-MM-DD"));
                                }}
                                views={["year", "month", "date"]}
                                style={{ margin: "15px 0px", width: "200px" }}
                            />
                            <KeyboardDatePicker
                                label="End Date*"
                                dateformat="YYYY-MM-DD"
                                value={selectedEndDate === null ? null : moment(selectedEndDate).tz(localtz)}
                                minDate={moment(selectedDate).tz(localtz)}
                                onChange={() => null}
                                onAccept={(value) => {
                                    setSelectedEndDate(moment(value).format("YYYY-MM-DD"));
                                }}
                                views={["year", "month", "date"]}
                                style={{ margin: "15px 0px", width: "200px" }}
                                disabled={endDateNull}
                            />
                            <FormGroup row style={{ marginTop: "30px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={endDateNull}
                                            onChange={handleEndDateNullClick}
                                            color="primary"
                                        />
                                    }
                                    label="No End Date"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label='TDSP*'
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={rowTDSPName || ''}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label='Rate Type*'
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={rowRateTypeName || ''}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Status*"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={statuses[0] || ''}
                                    select
                                    onChange={handleTDSPStatusChange}
                                >
                                    {statuses && statuses.sort().map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate Class*"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    select
                                    value={newRateRequest.class_type_id || ''}
                                    disabled={false}
                                    onChange={handleTDSPRateClassChange}
                                >
                                    {rateClasses && rateClasses.sort((a, b) => a.type.localeCompare(b.type)).map(item => <MenuItem key={item.id} value={item.id}>{item.type}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate Zone (Optional)"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    select
                                    value={newRateRequest.zone_id || ''}
                                    onChange={handleTDSPZoneChange}
                                    disabled={(zones?.filter(item => item.tdsp_id === tdsp_id).length === 0)}
                                >
                                    {zones && zones.sort((a, b) => a.zone.localeCompare(b.zone)).filter(item => item.tdsp_id === tdsp_id).map(item => <MenuItem key={item.id} value={item.id}>{item.zone}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate*"
                                    type="number"
                                    size="small"
                                    color="primary"
                                    value={newRateRequest.rate}
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                        step: "0.0001",
                                        min: newRateRequest.rate_type_id === "7" ? null : newRateRequest.rate_type_id !== "2" ? "0.01" : "0",
                                        ...(newRateRequest.rate_type_id !== "2" && {max: "0.99"}),
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                                    }}
                                    variant="outlined"
                                    onChange={handleTDSPRateChange}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ marginRight: '20px', marginLeft: '20px' }}>
                <Button
                    color="secondary"
                    variant="contained"
                    style={{
                        float: "right",
                        marginRight: 5,
                        marginBottom: 10,
                    }}
                    onClick={() => {
                        setEndDateNull(false)
                        doCreateTDSPRate(newRateRequest, 0, 100)
                        setNewRateRequest({
                            tdsp_id: 0,
                            rate_type_id: 0,
                            class_type_id: 0,
                            zone_id: 0,
                            rate: 0.0,
                            start_date: "",
                            user_id: user_id,
                            end_date: "",
                            status: ""
                        });
                        setShowPlusMode(false)
                    }}
                    disabled={setCreateDisabled}
                >
                    Create
                </Button>
                <Button
                    onClick={() => {
                        setEndDateNull(false)
                        setNewRateRequest({
                            tdsp_id: 0,
                            rate_type_id: 0,
                            class_type_id: 0,
                            zone_id: 0,
                            rate: 0.0,
                            start_date: "",
                            user_id: user_id,
                            end_date: "",
                            status: ""
                        });
                        setShowPlusMode(false)
                    }}
                    color="primary"
                    variant="contained"
                    style={{
                        float: "right",
                        marginRight: 20,
                        marginBottom: 10,
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const EditMode = ({ doEditTDSPRate, user_id, rowData, showEditMode, setShowEditMode }) => {
    const localtz = moment.tz.guess();

    const [selectedDate, setSelectedDate] = useState(rowData.startDate);
    const [selectedEndDate, setSelectedEndDate] = useState(rowData.endDate ? rowData.endDate : null);
    const [endDateNull, setEndDateNull] = useState(selectedEndDate === null)
    const [isEditMade, setIsEditMade] = useState(false)
    const [newRateRequest, setNewRateRequest] = useState({
        rate: rowData.rate,
        start_date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
        end_date: endDateNull === true ? null : `${moment(selectedEndDate).format("YYYY-MM-DD")}`,
        user_id: user_id,
        status: rowData.status,
        id: rowData.rateId,
    })

    const statuses = ['actual', 'proposed', 'forecasted']

    const handleTDSPRateChange = (event) => {

        let value = parseFloat(event.target.value) || ""

        if (parseFloat(event.target.value) === 0) {
            value = 0
        }

        if ((value < 0 || value > 0.99) && rowData.rateTypeName !== "tdsp_base" && rowData.rateTypeName !== "reconcilliation_adder") {
            return
        }

        setNewRateRequest(prevState => ({
            ...prevState,
            rate: value
        }));
    }

    const handleStatusChange = (event) => {
        setNewRateRequest(prevState => ({
            ...prevState,
            status: event.target.value
        }));
    }

    const handleEndDateNullClick = (event) => {
        setEndDateNull(event.target.checked)
    }

    const setUpdateDisabled = !isEditMade ||
        (newRateRequest.rate <= 0.0 && rowData.rateTypeName !== "reconcilliation_adder") ||
        newRateRequest.rate === "" ||
        isNaN(newRateRequest.rate) ||
        (newRateRequest.end_date === null && !endDateNull) ||
        (newRateRequest.rate < 0.01 && rowData.rateTypeName !== "tdsp_base" && rowData.rateTypeName !== "reconcilliation_adder");

    useEffect(() => {

        if (moment(selectedEndDate).isBefore(moment(selectedDate))) {
            setSelectedEndDate(selectedDate)
        }

        setNewRateRequest(prevState => ({
            ...prevState,
            start_date: `${moment(selectedDate).format("YYYY-MM-DD")}`,
            end_date: endDateNull === true || !selectedEndDate ? null : `${moment(selectedEndDate).format("YYYY-MM-DD")}`
        }));

        const row_start_date = moment(rowData.startDate).format("YYYY-MM-DD")
        const row_end_date = rowData.endDate ? moment(rowData.endDate).format("YYYY-MM-DD") : null
        const request_start_date = moment(selectedDate).format("YYYY-MM-DD")
        const request_end_date = endDateNull || !selectedEndDate ? null : moment(selectedEndDate).format("YYYY-MM-DD")
        const row_rate = parseFloat(rowData.rate)
        const request_rate = parseFloat(newRateRequest.rate)

        const editMade = request_rate !== row_rate || newRateRequest.status !== rowData.status || request_start_date !== row_start_date || request_end_date !== row_end_date

        setIsEditMade(editMade)

    }, [selectedDate, selectedEndDate, endDateNull, newRateRequest.rate, newRateRequest.status]);

    return (
        <Dialog
            open={showEditMode}
            ariaHideApp={false}
            fullWidth={true}
            maxWidth={"md"}
        >
            <DialogTitle style={{ marginRight: '20px', marginLeft: '20px' }}>
                Edit Rate
            </DialogTitle>
            <DialogContent style={{ overflow: 'hidden' }}>
                <DialogContentText style={{ marginRight: '20px', marginLeft: '20px' }}>
                    <Grid container>
                        <Grid style={{ gap: '20px', display: 'flex', alignItems: 'center' }} item sm={12}>
                            <KeyboardDatePicker
                                label="Start Date*"
                                dateformat="YYYY-MM-DD"
                                value={moment(selectedDate).tz(localtz)}
                                minDate={moment("1900-01-01")}
                                onChange={() => null}
                                onAccept={(value) => {
                                    setSelectedDate(moment(value).format("YYYY-MM-DD"));
                                }}
                                views={["year", "month", "date"]}
                                style={{ margin: "15px 0px", width: "200px" }}
                            />
                            <KeyboardDatePicker
                                label="End Date*"
                                dateformat="YYYY-MM-DD"
                                value={selectedEndDate === null ? null : moment(selectedEndDate).tz(localtz)}
                                minDate={moment(selectedDate).tz(localtz)}
                                onChange={() => null}
                                onAccept={(value) => {
                                    setSelectedEndDate(moment(value).format("YYYY-MM-DD"));
                                }}
                                views={["year", "month", "date"]}
                                style={{ margin: "15px 0px", width: "200px" }}
                                disabled={endDateNull}
                            />
                            <FormGroup row style={{ marginTop: "30px" }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={endDateNull}
                                            onChange={handleEndDateNullClick}
                                            color="primary"
                                        />
                                    }
                                    label="No End Date"
                                />
                            </FormGroup>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label='TDSP*'
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={rowData.tdspName || ''}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label='Rate Type*'
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={rowData.rateTypeName || ''}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Status*"
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={rowData.status || ''}
                                    select
                                    onChange={handleStatusChange}
                                >
                                    {statuses && statuses.sort().map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                </TextField>
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label='Rate Class*'
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={rowData.rateClassName || ''}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label='Rate Zone (Optional)'
                                    type="text"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    InputLabelProps={{ shrink: true }}
                                    variant="outlined"
                                    defaultValue={rowData.zoneName || ''}
                                    disabled={true}
                                />
                            </FormControl>
                        </Grid>
                        <Grid style={{ marginTop: '10px' }} item sm={12}>
                            <FormControl variant="outlined" size="small" fullWidth>
                                <TextField
                                    label="Rate*"
                                    type="number"
                                    size="small"
                                    color="primary"
                                    style={{ width: '100%' }}
                                    value={newRateRequest.rate}
                                    defaultValue={rowData.rate}
                                    InputLabelProps={{ shrink: true }}
                                    inputProps={{
                                        step: "0.0001",
                                        min: rowData.rateTypeName !== "reconcilliation_adder" ? null : rowData.rateTypeName !== "tdsp_base" ? "0.01" : "0",
                                        ...(rowData.rateTypeName !== "tdsp_base" && {max: "0.99"}),
                                    }}
                                    InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>
                                    }}
                                    variant="outlined"
                                    onChange={handleTDSPRateChange}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions style={{ marginRight: '20px', marginLeft: '20px' }}>
                <Button
                    color="secondary"
                    variant="contained"
                    style={{
                        float: "right",
                        marginRight: 5,
                        marginBottom: 10,
                    }}
                    onClick={() => {
                        setEndDateNull(false)
                        setIsEditMade(false)
                        doEditTDSPRate(newRateRequest, 0, 100)
                        setNewRateRequest({
                            rate: 0.0,
                            start_date: "",
                            user_id: user_id,
                            end_date: "",
                            status: "",
                            id: 0
                        });
                        setShowEditMode(false)
                    }}
                    disabled={setUpdateDisabled}
                >
                    Update
                </Button>
                <Button
                    onClick={() => {
                        setEndDateNull(false)
                        setIsEditMade(false)
                        setNewRateRequest({
                            rate: 0.0,
                            start_date: "",
                            user_id: user_id,
                            end_date: "",
                            status: "",
                            id: 0
                        });
                        setShowEditMode(false)
                    }}
                    color="primary"
                    variant="contained"
                    style={{
                        float: "right",
                        marginRight: 20,
                        marginBottom: 10,
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

const RateTable = ({ tdsp, tdsps, rateClasses, rateTypes, zones, user_id, doCreateTDSPRate, doEditTDSPRate }) => {

    const [rowTDSPName, setRowTDSPName] = useState(null)
    const [rowRateTypeName, setRowRateTypeName] = useState(null)
    const [showEditMode, setShowEditMode] = useState(false)
    const [showPlusMode, setShowPlusMode] = useState(false)
    const [rowData, setRowData] = useState({
        tdspName: null,
        rateClassName: null,
        rateTypeName: null,
        zoneName: null,
        startDate: null,
        endDate: null,
        status: null,
        rate: null,
        rateId: null,
    })

    const filterData = (filter, row) => { return row[filter.id]?.toLowerCase().startsWith(filter.value.toLowerCase()) }

    const columns = (rate_name) => [
        {
            Header: "Status",
            accessor: "status",
            Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>),
            filterMethod: filterData,
        },
        {
            Header: "Rate ($)",
            accessor: "rate",
            Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value ? "$" + Number(value).toLocaleString('en-US', { maximumFractionDigits: 50 }) : ""}</div>),
        },
        {
            Header: "Zone",
            accessor: "zone",
            Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>),
            filterMethod: filterData,
        },
        {
            Header: "Rate Type",
            accessor: "rate_type",
            Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>),
            filterMethod: filterData,
        },
        {
            Header: "Rate Class",
            accessor: "class_type",
            Cell: ({ value }) => (<div style={{ textAlign: 'center' }}>{value}</div>),
            filterMethod: filterData,
        },
        {
            Header: "Start Date",
            accessor: "start_date",
            Cell: ({ value }) => (value ? <div style={{ textAlign: 'center' }}>{new Date(value).toISOString().split("T")[0]}</div> : ""),
        },
        {
            Header: "End Date",
            accessor: "end_date",
            Cell: ({ value }) => (value ? <div style={{ textAlign: 'center' }}>{new Date(value).toISOString().split("T")[0]}</div> : ""),
        },
        {
            Header: "",
            resizable: false,
            filterable: false,
            width: 130,
            Cell: (row) => {
                const isFirstRow = row.index === 0 && row.original.data !== "empty"
                const isEmptyRow = row.original.data === "empty"

                return (
                    <EditSectionContainer>
                        {!isEmptyRow && <Tooltip placement="top" title="View/Edit Data">
                            <EditButton
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={() => {
                                    setRowData({
                                        tdspName: row.original.tdsp_name,
                                        rateClassName: row.original.class_type,
                                        rateTypeName: row.original.rate_type,
                                        zoneName: row.original.zone,
                                        startDate: row.original.start_date,
                                        endDate: row.original.end_date,
                                        status: row.original.status,
                                        rate: row.original.rate,
                                        rateId: row.original.rate_id,
                                    })
                                    setShowEditMode(true)
                                }}
                            >
                                Edit
                            </EditButton>
                        </Tooltip>}
                        {(isFirstRow || isEmptyRow) && (
                            <PlusButtonContainer>
                                <Tooltip title="Create New Rate">
                                    <IconButton
                                        color="secondary"
                                        onClick={() => {
                                            setRowTDSPName(row.original.tdsp_name)
                                            setRowRateTypeName(row.original.rate_type || rate_name)
                                            setShowPlusMode(true)
                                        }}
                                    >
                                        <AddIcon />
                                    </IconButton>
                                </Tooltip>
                            </PlusButtonContainer>
                        )}
                    </EditSectionContainer>
                )
            },
        },
    ];

    return (
        <div>

            <ReactTableTabs
                rate_list={tdsp.rate_list}
                columns={columns}
                rate_types={rateTypes}
            />

            {showPlusMode && <PlusIconMode
                showPlusMode={showPlusMode}
                setShowPlusMode={setShowPlusMode}
                rateClasses={rateClasses}
                rateTypes={rateTypes}
                zones={zones}
                tdsps={tdsps}
                doCreateTDSPRate={doCreateTDSPRate}
                rowTDSPName={rowTDSPName}
                setRowTDSPName={setRowTDSPName}
                user_id={user_id}
                rowRateTypeName={rowRateTypeName}
                setRowRateTypeName={setRowRateTypeName}
            />}

            {showEditMode && <EditMode
                showEditMode={showEditMode}
                setShowEditMode={setShowEditMode}
                user_id={user_id}
                doEditTDSPRate={doEditTDSPRate}
                rowData={rowData}
            />}

        </div>
    );
};

RateTable.propTypes = {};

export default RateTable;